import React, { Component } from "react";
import ReactDOM from "react-dom";
import { PayPalButton } from "react-paypal-button-v2";
import alertify from "alertifyjs";
import "../components/styles/Alertify.css";
import "../components/styles/AlertifyTheme.css";
import "../components/styles/Alertify.min.css";
import "../components/styles/AlertifyTheme.min.css";
import { connect } from "react-redux";
import { Translate, I18n } from "react-redux-i18n";
import * as actions_suscription from "../redux/actions/suscriptionPlanActions";
import {
  getPaypalSubscriptionOptions,
  getSubscriptionPlan,
  isPaypalConfigured,
  postSubscriptionToBackend,
} from "../utils/paypalConfig";

class PaypalSuscriptionTemp extends Component {
  constructor(props) {
    super(props);
    window.React = React;
    window.ReactDOM = ReactDOM;
  }

  handlePaypalError = () => {
    alertify.warning(I18n.t("try_later"));
  };

  render() {
    const { user_id, token, value } = this.props;
    const plan = getSubscriptionPlan(value);

    if (!isPaypalConfigured()) {
      return (
        <div className="alert alert-warning text-center" role="alert">
          PayPal: configure REACT_APP_PAYPAL_CLIENT_ID in .env and restart the
          dev server.
        </div>
      );
    }

    if (!plan) {
      return (
        <div className="alert alert-warning text-center" role="alert">
          <Translate value="try_later" />
        </div>
      );
    }

    return (
      <div className="text-center">
        <PayPalButton
          shippingPreference="NO_SHIPPING"
          options={getPaypalSubscriptionOptions()}
          createSubscription={(data, actions) =>
            actions.subscription.create({
              plan_id: plan.paypalPlanId,
            })
          }
          onApprove={(data, actions) =>
            actions.subscription.get().then((details) => {
              this.props.SetPlanNext(4);
              return postSubscriptionToBackend({
                data,
                details,
                userId: user_id,
                token,
                planGwId: plan.planId,
              });
            })
          }
          catchError={this.handlePaypalError}
          onError={this.handlePaypalError}
        />
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  SetPlanNext: (value) => dispatch(actions_suscription.setPlanNext({ value })),
});

function mapStateToProps(reducer) {
  return {
    user_id: reducer.session.auth.id,
    token: reducer.session.auth.access_token,
    value: reducer.suscriptionPlan.plan_value,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(PaypalSuscriptionTemp);
